import Cookies from 'js-cookie'
import axios from 'axios'

const state = {
  error: null,
  status: Cookies.get('user-auth_token') ? !!Cookies.get('user-auth_token') : false,
  auth_token: Cookies.get('user-auth_token'),
  cent_token: Cookies.get('user-cent_token'),
  user_role: Cookies.get('user-role')
};

const mutations = {
  AUTH_REQUEST: (state) => {
    state.auth_token = null;
    state.cent_token = null;
    state.error = null;
    state.status = null;
  },
  AUTH_SUCCESS: (state, {auth_token, cent_token}) => {
    state.auth_token = auth_token;
    state.cent_token = cent_token;
    state.error = null;
    state.status = true;
  },
  AUTH_ERROR: (state, err) => {
    state.error = err;
    state.auth_token = null;
    state.cent_token = null;
    state.status = false;
  },
  AUTH_CLEAN_ERROR: (state) => {
    state.error = null;
  },
  AUTH_LOGOUT: (state) => {
    state.status = false;
    state.auth_token = null;
    state.cent_token = null;
    state.error = null;
  },

};

const actions = {

  authRequest: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST');
      axios(
        {url: 'sync/login', data: user, method: 'POST'}
      ).then((resp) => {
        const {auth_token, cent_token, user_role} = resp.data;
        Cookies.set('user-auth_token', auth_token);
        Cookies.set('user-cent_token', cent_token);
        Cookies.set('user-role', user_role);
        // Add the following line:
        axios.defaults.headers.common['Authorization'] = `Bearer ${auth_token}`;
        commit('AUTH_SUCCESS', {auth_token, cent_token});
        dispatch('boards/getBoards', null, {root:true});
        dispatch('streams/getStreams', null, {root:true});
        resolve(resp)
      }).catch((error) => {
        let message = 'Request is invalid!';

        if (error.response) {
          message = error.response.data.message;
        } else if (error.message) {
          message = error.message;
        }

        commit('AUTH_ERROR', message);
        Cookies.remove('user-auth_token');
        Cookies.remove('user-cent_token');
        reject(error)
      });
    })
  },
  authCleanError: ({commit}) => {
    commit('AUTH_CLEAN_ERROR')
  },
  authLogout: ({commit}) => {
    return new Promise((resolve) => {
      commit('AUTH_LOGOUT')
      Cookies.remove('user-auth_token');
      Cookies.remove('user-cent_token');
      // remove the axios default header
      delete axios.defaults.headers.common['Authorization'];
      resolve()
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
